import { IGetUsersResponseProps } from '../../@types/services/users'

import * as integration from './integration'

const selectedModule = integration

export const getUsers: IGetUsers = selectedModule.getUsers

export type IGetUsers = () => Promise<IGetUsersResponseProps[]>
